// filepath: resources/assets/front/js/components/forms.js

export function initForms(element = document) {
  // Auto-resize textareas
  element.querySelectorAll('textarea[data-auto-resize]:not([data-auto-resize-init])').forEach(textarea => {
    textarea.addEventListener('input', function() {
      this.style.height = 'auto';
      this.style.height = this.scrollHeight + 'px';
    });
    
    textarea.setAttribute('data-auto-resize-init', 'true');
    
    // Déclencher une fois au chargement
    textarea.dispatchEvent(new Event('input'));
  });
  
  // Form validation feedback
  element.querySelectorAll('form[data-validate]:not([data-validate-init])').forEach(form => {
    form.addEventListener('submit', function(e) {
      if (!this.checkValidity()) {
        e.preventDefault();
        showFormErrors(this);
      }
    });
    
    form.setAttribute('data-validate-init', 'true');
  });
  
  if (element === document) {
    console.log('📝 Forms initialized');
  }
}

function showFormErrors(form) {
  form.querySelectorAll('[required]').forEach(field => {
    if (!field.checkValidity()) {
      field.classList.add('border-red-500');
      
      // Retirer la classe d'erreur quand l'utilisateur corrige
      field.addEventListener('input', function() {
        if (this.checkValidity()) {
          this.classList.remove('border-red-500');
        }
      }, { once: true });
    }
  });
}